var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EmployeeReport',{attrs:{"location_id":_vm.location_id}}),(_vm.IsAdmin())?_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_vm._v(" Edit Location ")]),(_vm.location !== null)?_c('div',{staticClass:"box-content content-padding"},[_c('LocationEditor',{attrs:{"location":_vm.location}})],1):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }